// src/utils/logError.js
import { doc, setDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";

/**
 * Logs an error to Firestore under /leagues/{leagueID}/errorLog/{autoID}.
 * Automatically adds timestamp and basic metadata for debugging.
 */
export async function logError({
  leagueID = "unknown",
  userID = "unknown",
  action = "unspecified",
  payload = {},
  error = "",
  env = process.env.NODE_ENV || "dev",
}) {
  try {
    const errorMessage =
      typeof error === "string" ? error : error?.message || "Unknown error";

    const entry = {
      timestamp: serverTimestamp(),
      leagueID,
      userID,
      action,
      payloadSummary:
        typeof payload === "object"
          ? JSON.stringify(payload).slice(0, 500)
          : String(payload),
      errorMessage,
      environment: env,
    };

    // ✅ Correct path: inside league document
    const logRef = doc(collection(db, "leagues", leagueID, "errorLog"));
    await setDoc(logRef, entry);

    console.error(
      `[ERROR LOGGED] (${action}) ${errorMessage} — League: ${leagueID}, User: ${userID}`
    );
  } catch (e) {
    console.error("🔥 Failed to write to /leagues/{leagueID}/errorLog:", e);
  }
}